<template>
  <div class="admission-missions-container">
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white" @click="confirmDialogConfirmFunction()" :disabled="disabelConfirm">
          بله
        </v-btn>
        <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()">
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog v-model="changeHospitalNoteModal" width="500" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-text</v-icon>
              <span class="modal-title-text mr-2">تغییر بیمارستان</span>
              <v-spacer></v-spacer>
              <v-icon @click="cancleChangeHospital()" class="ml-2">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-textarea rows="5" outlined label="توضیحات" dense type="text" clearable
                clear-icon="mdi-close-circle-outline" v-model="changeHospitalNote"
                v-on:keyup.enter="setChangeHospital()" class="input-label"
                prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="setChangeHospital()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancleChangeHospital()" class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cancelReasonHospitalModal" width="500" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-text</v-icon>
              <span class="modal-title-text mr-2">لغو بیمارستان</span>
              <v-spacer></v-spacer>
              <v-icon @click="closeOutOfServiceMoreInfo()" class="ml-2">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-textarea rows="5" outlined label="توضیحات" dense type="text" clearable
                clear-icon="mdi-close-circle-outline" v-model="cancelReasonHospitalNote"
                v-on:keyup.enter="setChangeHospital()" class="input-label"
                prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="removeHospital()" dark rounded class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancleCancleResoneHospital()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="outOfServiceMoreInfoModal" persistent width="650">
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-information</v-icon>
              <span class="modal-title-text mr-2">جزئیات</span>
              <v-spacer></v-spacer>
              <v-icon @click="closeOutOfServiceMoreInfo()" class="ml-2">mdi-close</v-icon>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="6">
              <v-card elevation="0" height="8vh" class="all-active-alarm-card">
                <v-row no-gutters>
                  <v-col cols="12" class="all-active-alarm-card-body">
                    <v-row no-gutters>
                      <v-col cols="12" class="mt-7">
                        <v-row class="mr-3">
                          <span class="all-active-alarm-card-body-items-title">بیمارستان:</span>
                          <span class="all-active-alarm-card-body-items-value mr-2">
                            {{ outOfServiceMoreInfoHospital }}
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card elevation="0" height="8vh" class="all-active-alarm-card">
                <v-row no-gutters>
                  <v-col cols="12" class="all-active-alarm-card-body">
                    <v-row no-gutters>
                      <v-col cols="12" class="mt-7">
                        <v-row class="mr-3">
                          <span class="all-active-alarm-card-body-items-title">کاربر:</span>
                          <span class="all-active-alarm-card-body-items-value mr-2">
                            {{ outOfServiceMoreInfoUser }}
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
            <v-col cols="12">
              <v-card elevation="0" height="8vh" class="all-active-alarm-card">
                <v-row no-gutters>
                  <v-col cols="12" class="all-active-alarm-card-body">
                    <v-row no-gutters>
                      <v-col cols="12" class="mt-7">
                        <v-row class="mr-3">
                          <span class="all-active-alarm-card-body-items-title">توضیحات:</span>
                          <span class="all-active-alarm-card-body-items-value mr-2">
                            {{ outOfServiceMoreInfoNote }}
                          </span>
                          <v-spacer></v-spacer>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog width="400" v-model="extendTimeModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-clock-time-four</v-icon>
              <span class="modal-title-text mr-2">تمدید زمان</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="extendHour" dense
                outlined v-on:keyup.enter="showConfirmDialogFunction()" label="مدت زمان (ساعت)"
                @keypress="isNumber($event)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                tabindex="1"></v-text-field>
            </v-col>
            <v-col cols="12" class="mt-n6">
              <v-text-field type="text" clearable clear-icon="mdi-close-circle-outline" v-model="extendMinute" dense
                @keypress="isNumber($event)" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="مدت زمان (دقیقه)" class="input-label" prepend-inner-icon="mdi-clock-time-four mdi-18px"
                tabindex="2"></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelExtendTimetFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="450" v-model="addOutOfServiceModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">mdi-plus</v-icon>
              <span class="modal-title-text mr-2">افزودن عدم پذیرش</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-5">
          <v-row>
            <v-col cols="12">
              <v-autocomplete hide-details :items="allActiveHospitals" no-data-text="اطلاعاتی وجود ندارد" tabindex="1"
                dense outlined clearable clear-icon="mdi-close-circle-outline" item-text="title" item-value="id"
                label="بیمارستان*" :autofocus="true" v-model="outOfServiceHospital.hospitalId" autocomplete="off"
                prepend-inner-icon="mdi-ambulance mdi-18px" style="font-size: 11px !important"></v-autocomplete>
            </v-col>
            <v-col cols="12" class="">
              <v-textarea hide-details type="text" v-model="outOfServiceHospital.note" dense clearable
                clear-icon="mdi-close-circle-outline" outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="توضیحات" class="input-label" prepend-inner-icon="mdi-text mdi-18px" rows="4"
                tabindex="2"></v-textarea>
            </v-col>
            <v-col cols="6" class="">
              <v-text-field hide-details type="text" clearable clear-icon="mdi-close-circle-outline"
                v-model="outOfServiceHospitalHour" dense outlined v-on:keyup.enter="showConfirmDialogFunction()"
                label="مدت زمان (ساعت)" @keypress="isNumber($event)" class="input-label"
                prepend-inner-icon="mdi-clock-time-four mdi-18px" tabindex="3"></v-text-field>
            </v-col>
            <v-col cols="6" class="">
              <v-text-field hide-details type="text" clearable clear-icon="mdi-close-circle-outline"
                v-model="outOfServiceHospitalMinute" dense @keypress="isNumber($event)" outlined
                v-on:keyup.enter="showConfirmDialogFunction()" label="مدت زمان (دقیقه)" class="input-label"
                prepend-inner-icon="mdi-clock-time-four mdi-18px" tabindex="4"></v-text-field>
            </v-col>
            <v-col cols="6" class="mt-n2">
              <v-checkbox v-model="outOfServiceHospital.isActive" label="فعالسازی انتخاب بیمارستان"
                hide-details></v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="showConfirmDialogFunction()" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelAddOutOfServiceFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog width="1200" v-model="sendToHospitalModal" persistent>
      <edit-admission-component v-if="sendToHospitalModal" :missionId="missionId" :missionPhoneId="missionPhoneId"
        :missionCode="missionPhoneCode" :phoneCode="phoneCode" :phoneId="phoneId">
        <template v-slot:boxEdit>
          <v-row class="mt-1">
            <span class="send-mission-title-content2 mr-3">
              اطلاعات ماموریت ( {{ missionStatus }} )
            </span>
            <v-divider class="mt-3 mr-2"></v-divider>
          </v-row>
          <v-row>
            <v-col cols="12" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">آدرس:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ missionSendToHospitalInfo.address }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="3" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">کدآمبولانس:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ missionSendToHospitalInfo.ambulanceCode }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col cols="6" class="mt-n4">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">شکایت اصلی:</span>
                        <span class="mr-2 mt-1 send-mission-info-text-content">
                          {{ missionSendToHospitalInfo.chiefComplaint }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="mt-n4">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">تشخیص:</span>
                        <span class="mr-2 mt-1 send-mission-info-text-content">
                          {{ missionSendToHospitalInfo.admission }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="3" class="mt-n4">
              <v-card class="card-info-send-mission" elevation="0" height="5vh">
                <v-card-text>
                  <v-row>
                    <span class="mt-1 send-mission-info-title-content">کد شبرنگ:</span>
                    <span class="mr-2 mt-1 send-mission-info-text-content">
                      {{ missionSendToHospitalInfo.shabrang }}
                    </span>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
            <v-col cols="9">
              <v-row>
                <v-col cols="6" class="mt-n4">
                  <v-card class="card-info-send-mission" elevation="0" height="5vh">
                    <v-card-text>
                      <v-row>
                        <span class="mt-1 send-mission-info-title-content">وضعیت کد:</span>
                        <span class="mr-2 mt-1 send-mission-info-text-content">
                          {{ missionSendToHospitalInfo.codeStatus }}
                        </span>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="6" class="mt-n3">
                  <v-row no-gutters>
                    <v-col cols="10">
                      <v-card class="card-info-send-mission" elevation="0" height="5vh">
                        <v-card-text>
                          <v-row>
                            <span class="mt-1 send-mission-info-title-content">
                              شماره تماس:
                            </span>
                            <span class="mr-2 mt-1 x-overflow send-mission-info-text-content">
                              {{
                                missionSendToHospitalInfo.phoneNumber
                                  ? missionSendToHospitalInfo.phoneNumber
                                  : '-'
                              }}
                            </span>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="1" class="mt-1 mr-1">
                      <v-btn color="darkColor" small class="py-4" block
                        @click="callToPatient(missionSendToHospitalInfo.phoneNumber)">
                        <v-icon color="white">mdi-phone mdi-18px</v-icon>
                      </v-btn>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="8" class="mt-n2">
              <v-row>
                <span class="send-mission-title-content2 mr-3">موقعیت</span>
                <v-divider class="mt-3 mr-2 ml-2"></v-divider>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <div id="map">
                    <l-map v-if="isMapReadyToShow" ref="modalmap" style="height: 54vh !important" :zoom="zoom"
                      :center="center" :options="mapOptions" @update:center="centerUpdate" @update:zoom="zoomUpdate"
                      @ready="mapInvalidate()" @click="add800SelectedMarker">
                      <l-tile-layer :url="mapTileUrl" :attribution="attribution"></l-tile-layer>
                      <l-marker v-for="item in allMapHospitals" :key="item.id" :lat-lng="[item.lat, item.lng]"
                        :icon="hospitalIcon">
                        <l-tooltip>{{ item.title }}</l-tooltip>
                      </l-marker>
                      <l-marker ref="marker" v-if="phoneOnlineLocation"
                        :lat-lng="[phoneOnlineLocation.latitude, phoneOnlineLocation.longitude]"
                        :icon="getMovingIcon(phoneOnlineLocation)">
                        <l-popup ref="popup">{{ phoneOnlineLocation?.phone?.code }}</l-popup>
                      </l-marker>
                    </l-map>
                  </div>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="4" class="mt-n2">
              <v-row>
                <v-col cols="12">
                  <v-card height="14vh" elevation="0" class="send-mission-detail-card">
                    <v-row no-gutters>
                      <span class="send-mission-title-content">تگ های مناسبتی</span>
                    </v-row>
                    <v-card-text class="send-mission-detail-card-body">
                      <v-row>
                        <v-col cols="10" class="mt-n5">
                          <v-autocomplete :items="allTagsForOther" no-data-text="اطلاعاتی وجود ندارد" dense
                            item-text="title" item-value="id" placeholder="انتخاب برچسب" autocomplete="off"
                            v-model="selectedtag"></v-autocomplete>
                        </v-col>
                        <v-col cols="2" class="mt-n4 mr-n4">
                          <v-btn color="darkColor" small class="py-3" block elevation="0" @click="addMissionTag()">
                            <v-icon color="white">mdi-plus mdi-18px</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                      <v-chip close class="mr-1 mt-1" close-icon="mdi-close"
                        @click:close="removeTagFromMissionByAdmissionFunction(item.id)" small
                        v-for="item in selectedTagsList" :key="item.id">
                        {{ item.tag.title }}
                      </v-chip>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card height="12vh" elevation="0" class="send-mission-detail-card">
                    <v-row no-gutters>
                      <span class="send-mission-title-content">
                        نزدیک ترین بیمارستان های پیشنهادی
                      </span>
                    </v-row>
                    <v-card-text class="send-mission-detail-card-body">
                      <v-row v-if="topNearestLoaderFlag == false">
                        <v-chip @click="selectHospitalFromAdvice(item)" class="mr-2"
                          v-for="item in topNearestHospitalList" small color="background" :key="item.id">
                          {{ item.title }}
                        </v-chip>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-progress-linear indeterminate color="lightColor" rounded height="8"></v-progress-linear>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-card height="12vh" elevation="0" class="send-mission-detail-card">
                    <v-row no-gutters>
                      <span class="send-mission-title-content">
                        بیمارستان های پیشنهادی بر اساس تشخیص
                      </span>
                    </v-row>
                    <v-card-text class="send-mission-detail-card-body">
                      <v-row v-if="topNearestDignosisLoaderFlag == false">
                        <v-chip @click="selectHospitalFromAdvice(item)" class="mr-2"
                          v-for="item in nearestDignosisHospitalList" small color="background" :key="item.id">
                          {{ item.title }}
                        </v-chip>
                      </v-row>
                      <v-row v-else>
                        <v-col cols="12">
                          <v-progress-linear indeterminate color="lightColor" rounded height="8"></v-progress-linear>
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" class="mt-n3">
                  <v-autocomplete :items="allActiveHospitals" no-data-text="اطلاعاتی وجود ندارد" dense outlined
                    item-text="title" item-value="id" label="بیمارستان" clearable :autofocus="true" tabindex="1"
                    clear-icon="mdi-close-circle-outline" autocomplete="off"
                    prepend-inner-icon="mdi-file-document mdi-18px" v-model="selectedHospital"></v-autocomplete>
                </v-col>
                <v-col cols="2" class="mt-n3 mr-n4">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="darkColor" v-bind="attrs" v-on="on" block elevation="0" :disabled="!hasHospital"
                        @click="setRemoveHospital()">
                        <v-icon color="white">mdi-close mdi-18px</v-icon>
                      </v-btn>
                    </template>
                    <span>لغو بیمارستان</span>
                  </v-tooltip>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="mt-n10">
                  <v-btn rounded dark tabindex="2" color="darkColor" block @click="setHospital()">
                    ثبت
                  </v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </edit-admission-component>
    </v-dialog>
    <v-dialog v-model="editNotemodal" width="400" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor" class="ml-2">mdi-pencil</v-icon>
              <span class="modal-title-text ma-0">ویرایش توضیحات </span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-8">
          <v-row>
            <v-col cols="12">
              <v-textarea outlined label="توضیحات" dense clearable rows="4" clear-icon="mdi-close-circle-outline"
                v-model="notReason" prepend-inner-icon="mdi-text mdi-18px"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn color="darkColor" @click="modifyOutOfServiceHospitalFunction(notReason)" dark rounded
            class="normal-letter-spacing px-12">
            ثبت
          </v-btn>
          <v-btn rounded color="darkColor" outlined @click="cancelEditNoteFunction()"
            class="normal-letter-spacing px-10">
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row>
      <v-col cols="9" class="mt-4">
        <v-card height="50vh" elevation="0" class="mission-800-list-card">
          <v-card-text>
            <div class="topControlBox">
              <span class="current-mission-header-content">
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon id="iconDatabase" size="18" color="#464646" @click="openColumnManager" v-bind="attrs"
                      v-on="on">
                      mdi-database-edit
                    </v-icon>
                  </template>
                  <span>
                    چیدمان جدول
                  </span>
                </v-tooltip>
                <v-icon class="ml-2" @click="refreshManual('topList')">
                  mdi-cached mdi-18px
                </v-icon>
                ماموریت های جاری
              </span>
              <v-text-field hide-details rounded dense outlined placeholder="جستجو..."
                class="current-mission-text-field" v-model="currentMissionSearchText"></v-text-field>
            </div>
            <template>
              <v-data-table id="admission_top_table" fixed-header multi-sort dense height="calc(50vh - 55px)"
                class="elevation-0 top-table" :defaultHeaders="admissionTopListTableHeader"
                :headers="currentHeaders.filter(h => h.isActive !== false)" :search="currentMissionSearchText"
                :items="admissionTopList" :items-per-page="admissionTopList.length" :hide-default-footer="true"
                @contextmenu:row="rightClickHandler" @dblclick:row="showSendToHospitalModal"
                @click:row="invokeToCodeInMap">
                <template v-slot:[`item.icon`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon :class="item.iconClass" :color="item.iconColor" v-bind="attrs" v-on="on">
                        mdi-car-emergency mdi-18px
                      </v-icon>
                    </template>
                    <span>وضعیت {{ item.rank }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.codeStatus`]="{ item }">
                  <!-- <v-row v-if="shouldShowSpecialStatus(item.codeStatus + '')" class="bottom-list-status-10-99"
                        no-gutters>
                        <v-col cols="12" class="text-right mt-1 pr-2">
                          <app-wrap-text :text="item.codeStatus" />
                        </v-col>
                      </v-row>
                      <v-row v-else no-gutters>
                        <v-col cols="12" class="text-right">
                          <app-wrap-text :text="item.codeStatus" />
                        </v-col>
                      </v-row> -->

                  <v-row v-if="item.markPhoneCurrentState" class="bottom-list-status-10-99" no-gutters>
                    <v-col cols="12" class="text-center mt-1 pr-2">
                      <app-wrap-text :text="item?.codeStatus ?? ''" />
                    </v-col>
                  </v-row>
                  <v-row v-else no-gutters>
                    <v-col cols="12" class="text-center">
                      <app-wrap-text :text="item?.codeStatus ?? ''" />
                    </v-col>
                  </v-row>

                </template>
                <template v-slot:no-data>
                  <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3" class="mt-4 pr-0">
        <v-card height="50vh" elevation="0" class="first-bottom-list-main-card">
          <v-card-text>
            <div class="topControlBox" style="gap: 8px !important;">
              <span class="stay-hospital-header-content">
                <v-icon class="ml-1" @click="refreshManual('topList')">
                  mdi-cached mdi-18px
                </v-icon>
                ماندگاری در بیمارستان
              </span>
              <v-text-field hide-details rounded placeholder="جستجو..." outlined v-model="stayInHospitalSearchText"
                dense class="stay-hospital-text-field"></v-text-field>
            </div>
            <template>
              <v-data-table fixed-header :headers="stayInHospitalListTableHeader" :items="stayInHospitalList"
                :items-per-page="stayInHospitalList.length" height="calc(50vh - 55px)" dense
                :search="stayInHospitalSearchText" :hide-default-footer="true" multi-sort
                class="elevation-0 stay-table">
                <template v-slot:no-data>
                  <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="8">
        <v-card height="calc(40vh - 25px)" elevation="0" class="third-bottom-list-main-card">
          <v-card-text>
            <div class="topControlBox">
              <span class="out-of-service-header-content">
                <v-icon class="ml-3" @click="refreshManual('outOfService')">
                  mdi-cached mdi-18px
                </v-icon>
                عدم پذیرش بیمارستان
              </span>
              <v-text-field hide-details rounded placeholder="جستجو..." outlined v-model="outOfServiceSearchText" dense
                class="out-of-service-text-field"></v-text-field>
              <v-btn rounded small color="darkColor" elevation="0" dark class="normal-letter-spacing"
                @click="enableAddOutOfServiceFunction()">
                <v-icon color="white">mdi-plus mdi-18px</v-icon>
                افزودن عدم پذیرش
              </v-btn>
            </div>
            <template>
              <v-data-table fixed-header :headers="outOfServiceListTableHeader" :items="allActiveOutOfServiceHospitals"
                :items-per-page="allActiveOutOfServiceHospitals.length" height="calc(40vh - 75px)" dense
                @contextmenu:row="rightClickHandler1" :search="outOfServiceSearchText" :hide-default-footer="true"
                multi-sort class="elevation-0 out-of-service-table">
                <template v-slot:[`item.note`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="note-multiline">
                        {{ item.note || 'بدون توضیحات' }}
                      </span>
                    </template>
                    <span>{{ item.note || 'بدون توضیحات' }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:[`item.duration`]="{ item }">
                  <div class="alarmTxtIcon">
                    <v-tooltip top v-if="item?.hasAlarm">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon style="cursor: pointer" @click="showExtendTimeModal(item.id)" v-bind="attrs" v-on="on"
                          size="18px" color="#f56060">
                          mdi-timer-alert-outline mdi-18px
                        </v-icon>
                      </template>
                      <span>پایان زمان عدم پذیرش</span>
                    </v-tooltip>
                    <span>
                      {{ item.duration }}
                    </span>
                  </div>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="iconColor" class="ml-1" v-bind="attrs" @click="showEditNoteModal(item)" v-on="on">
                        mdi-pencil mdi-18px
                      </v-icon>
                    </template>
                    <span>ویرایش توضیحات</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="iconColor" v-bind="attrs" @click="showExtendTimeModal(item.id)" v-on="on">
                        mdi-clock-time-four mdi-18px
                      </v-icon>
                    </template>
                    <span>تمدید زمان</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="iconColor" v-bind="attrs" v-on="on" class="mr-1"
                        @click="showOutOfServiceMoreInfoModal(item)">
                        mdi-information mdi-18px
                      </v-icon>
                    </template>
                    <span>جزئیات</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon color="iconColor" v-bind="attrs" v-on="on" class="mr-1"
                        @click="showEndConfirmFunction(item.id)">
                        mdi-delete mdi-18px
                      </v-icon>
                    </template>
                    <span>لغو عدم پذیرش</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                </template>
              </v-data-table>
            </template>
            <!-- //غیرفعال ترکیب با جدول بالا -->
            <!-- <v-row>
              <v-col cols="12">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-for="item in allActiveWithAlarmOutOfServiceHospitals" :key="item.id"
                class="has-alarm-part">
                <v-card elevation="0" height="8vh" class="all-active-alarm-card">
                  <v-row no-gutters>
                    <v-col cols="12" class="all-active-alarm-card-body">
                      <v-row no-gutters>
                        <v-col cols="11" class="mt-7">
                          <v-row>
                            <v-col cols="4">
                              <v-row class="mr-3">
                                <span class="all-active-alarm-card-body-items-title">
                                  بیمارستان:
                                </span>
                                <span class="all-active-alarm-card-body-items-value mr-2">
                                  {{ item.hospital }}
                                </span>
                                <v-spacer></v-spacer>
                              </v-row>
                            </v-col>
                            <v-col cols="4">
                              <v-row>
                                <v-spacer></v-spacer>
                                <span class="all-active-alarm-card-body-items-title">
                                  زمان:
                                </span>
                                <span class="all-active-alarm-card-body-items-value mr-2">
                                  {{ item.time }}
                                </span>
                                <v-spacer></v-spacer>
                              </v-row>
                            </v-col>
                            <v-col cols="4">
                              <v-row>
                                <v-spacer></v-spacer>
                                <span class="all-active-alarm-card-body-items-title">
                                  مدت زمان:
                                </span>
                                <v-chip color="background" small
                                  class="px-4 mr-2 all-active-alarm-card-body-items-value-time">
                                  {{ item.duration }}
                                </v-chip>
                                <v-spacer></v-spacer>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="1" class="mt-7">
                          <v-row class="">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="iconColor" style="cursor: pointer" @click="showExtendTimeModal(item.id)"
                                  v-bind="attrs" v-on="on">
                                  mdi-clock-time-four mdi-18px
                                </v-icon>
                              </template>
                              <span>تمدید زمان</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon color="iconColor" class="mr-1" style="cursor: pointer"
                                  @click="showOutOfServiceMoreInfoModal(item)" v-bind="attrs" v-on="on">
                                  mdi-information mdi-18px
                                </v-icon>
                              </template>
                              <span>جزئیات</span>
                            </v-tooltip>
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon class="mr-1" color="iconColor" style="cursor: pointer"
                                  @click="showEndConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                  mdi-car-emergency mdi-18px
                                </v-icon>
                              </template>
                              <span>10-10</span>
                            </v-tooltip>
                            <v-spacer></v-spacer>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4" class="pr-0">
        <v-card height="calc(40vh - 25px)" elevation="0" class="second-bottom-list-main-card">
          <v-card-text>
            <div class="topControlBox">
              <span class="hospital-header-content">
                <v-icon class="ml-3" @click="refreshManual('hospital')">
                  mdi-cached mdi-18px
                </v-icon>
                بیمارستان ها
              </span>
              <v-text-field hide-details rounded placeholder="جستجو..." outlined v-model="hospitalSearchText" dense
                class="hospital-text-field"></v-text-field>
            </div>
            <template>
              <v-data-table fixed-header :headers="hospitalListTableHeader" :items="hospitalList"
                :items-per-page="hospitalList.length" height="calc(40vh - 75px)" dense :loading="hospitalLoader"
                @contextmenu:row="rightClickHandler2" loading-text="به روزرسانی.... لطفا منتظر بمانید"
                :search="hospitalSearchText" :hide-default-footer="true" multi-sort class="elevation-0 hospital-table">
                <template v-slot:[`item.icon`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon :class="item.iconClass" :color="item.iconColor" v-bind="attrs" v-on="on">
                        mdi-car-emergency mdi-18px
                      </v-icon>
                    </template>
                    <span>وضعیت {{ item.rank }}</span>
                  </v-tooltip>
                </template>
                <template v-slot:no-data>
                  <span>اطلاعاتی جهت نمایش وجود ندارد</span>
                </template>
              </v-data-table>
            </template>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
      :snakIcon="snakIcon"></alert-component>
    <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute :close-on-content-click="closeOnContentClick"
      offset-y style="z-index: 99999999999">
      <v-list dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index10) in visibleRightClickItems" :key="'qq' + index10" dense>
            <v-list-item-icon>
              <v-icon color="darkColor">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس داخلی'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-text-field label="شماره تماس" dense v-model="iternalPhoneNumber">
                  <template v-slot:append-outer>
                    <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                      <v-icon color="white">mdi-phone mdi-18px mdi-flip-h</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس خارجی'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-text-field placeholder="شماره تماس" dense small v-model="externalPhoneNumber">
                  <template v-slot:append-outer>
                    <v-btn x-small color="darkColor" dark class="py-3" @click="rightClickAction(item.title, null)">
                      <v-icon color="white">mdi-phone-forward mdi-18px mdi-flip-h</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با کد'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item @click="rightClickAction(item.title, codePhoneNumbers)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ codePhoneNumbers }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با بیمارستان'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sitem, index) in hospitalPhoneNumbers_mission" :key="'h' + index"
                  @click="rightClickAction(item.title, sitem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با مددجو'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sitem, index) in patientPhoneNumbers" :key="'c' + index"
                  @click="rightClickAction(item.title, sitem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sitem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-menu v-model="showMenu1" :position-x="x1" :position-y="y1" absolute
      :close-on-content-click="closeOnContentClick1" offset-y style="z-index: 99999999999">
      <v-list dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index10) in rightClickItems1" :key="'qq1' + index10" dense>
            <v-list-item-icon>
              <v-icon color="darkColor">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با بیمارستان'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sItem, index) in hospitalPhoneNumbers" :key="'es' + index"
                  @click="rightClickAction1(item.title, sItem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sItem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
    <v-menu v-model="showMenu2" :position-x="x2" :position-y="y2" absolute
      :close-on-content-click="closeOnContentClick2" offset-y style="z-index: 99999999999">
      <v-list dense>
        <v-list-item-group>
          <v-list-item v-for="(item, index10) in rightClickItems2" :key="'opl' + index10" dense>
            <v-list-item-icon>
              <v-icon color="darkColor">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content class="mr-n8 mt-n2" v-if="item.title == 'تماس با بیمارستان'">
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item v-for="(sItem, index) in hospitalPhoneNumbers" :key="'hgf' + index"
                  @click="rightClickAction2(item.title, sItem)">
                  <v-list-item-content>
                    <v-list-item-title class="mr-3">{{ sItem }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>

    <column-manager-dialog :is-reverse="false" v-model="showColumnManager" :headers="currentHeaders"
      :defaultHeaders="admissionTopListTableHeader" :fixedValues="['icon']" @submit="applyNewHeaders" />
  </div>
</template>
<script>
import Vue from 'vue';
import { latLng } from 'leaflet';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
import AlertComponent from '../../components/AlertComponent.vue';
import confirmDialog from '../../components/ConfirmDialog.vue';
// import DispatchNoteComponent from '@/components/800/DispatchNoteComponent.vue';
import SharedMap from '@/Mixins/map';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import AdmissionMissionsHelper from '../../Helpers/Admission/AdmissionMissionsHelper.js';
import MissionPhonesMixin from '@/Mixins/Mission/MissionPhonesMixin';
import HospitalMixin from '@/Mixins/BaseInformation/HospitalMixin';
import OutOfServiceHospitalMixin from '@/Mixins/800/OutOfServiceHospitalMixin.js';
import TagMixin from '@/Mixins/BaseInformation/TagMixin.js';
import MissionMixin from '@/Mixins/Mission/MissionMixin.js';
import PhoneOnlineLocationMixin from '@/Mixins/BaseInformation/PhoneOnlineLocationMixin';
import MissionNoteMixin from '@/Mixins/Mission/MissionNoteMixin';
import CallMixin from '@/Mixins/Call/CallMixin';
import OtherOrganizationMixin from '@/Mixins/BaseInformation/OtherOrganizationMixin';
import AppWrapText from '@/components/app/wrapText.vue';
import EditAdmissionComponent from '@/components/admission/EditAdmissionComponent.vue';
import UserGridSettingsMixin from '@/Mixins/BaseInformation/UserGridSettingsMixin.js';
import ColumnManagerDialog from '@/components/800/ColumnManagerDialog.vue';

// Inline throttle (leading + trailing, no lodash / no helper file):
// first signal in a burst fires immediately, the LAST signal in a burst
// always triggers one final run, everything in between is dropped.
// Exposes .cancel() for cleanup in beforeDestroy.
function throttleFn(fn, wait) {
  let lastRun = 0;
  let timer = null;
  const invoke = () => {
    lastRun = Date.now();
    timer = null;
    fn();
  };
  const throttled = function () {
    const remaining = wait - (Date.now() - lastRun);
    if (remaining <= 0) {
      if (timer) {
        clearTimeout(timer);
        timer = null;
      }
      invoke(); // leading edge
    } else if (!timer) {
      timer = setTimeout(invoke, remaining); // trailing edge
    }
  };
  throttled.cancel = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };
  return throttled;
}

export default {
  name: 'MissionAdmissionView',
  title: 'ماموریت های پذیرش',
  inject: ['load'],
  components: {
    AlertComponent,
    confirmDialog,
    LMap,
    LTileLayer,
    LMarker,
    LTooltip,
    // DispatchNoteComponent,
    AppWrapText,
    EditAdmissionComponent,
    ColumnManagerDialog
  },
  mixins: [
    snackBar,
    ShearedMixin,
    ShearedHelper,
    AdmissionMissionsHelper,
    MissionPhonesMixin,
    HospitalMixin,
    OutOfServiceHospitalMixin,
    TagMixin,
    MissionMixin,
    PhoneOnlineLocationMixin,
    MissionNoteMixin,
    CallMixin,
    SharedMap,
    OtherOrganizationMixin,
    UserGridSettingsMixin
  ],
  created() {
    this.$root.$refs.MissionAdmissionView = this;
    this.currentHeaders = [...this.admissionTopListTableHeader];

    this.admissionInFlight = false;
    this.admissionPending = false;
    this.hospitalInFlight = false;
    this.hospitalPending = false;
    this.outOfServiceInFlight = false;
    this.outOfServicePending = false;

    this.throttledMainListAdmission = throttleFn(() => this.refreshAdmissionList(false), 1500);
    this.throttledHospitalList = throttleFn(() => this.refreshHospitalList(false), 1500);
    this.throttledOutOfServiceHospital = throttleFn(() => this.refreshOutOfServiceList(false), 1500);

    this.$mainSignalr.bus.$on('MainListAdmission', this.throttledMainListAdmission);
    this.$mobileSignalr.bus.$on('MainListAdmission', this.throttledMainListAdmission);
    this.$mainSignalr.bus.$on('HospitalList', this.throttledHospitalList);
    this.$mobileSignalr.bus.$on('HospitalList', this.throttledHospitalList);
    this.$mainSignalr.bus.$on('WaitInHospitalList', this.throttledMainListAdmission);
    this.$mobileSignalr.bus.$on('WaitInHospitalList', this.throttledMainListAdmission);
    this.$mainSignalr.bus.$on('OutOfServiceHospital', this.throttledOutOfServiceHospital);
    this.$mobileSignalr.bus.$on('OutOfServiceHospital', this.throttledOutOfServiceHospital);

    this.$mainSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$on('DispatchNotification', this.fNotifyOutOfService);

  },
  beforeDestroy() {
    this.$mainSignalr.bus.$off('MainListAdmission', this.throttledMainListAdmission);
    this.$mobileSignalr.bus.$off('MainListAdmission', this.throttledMainListAdmission);
    this.$mainSignalr.bus.$off('HospitalList', this.throttledHospitalList);
    this.$mobileSignalr.bus.$off('HospitalList', this.throttledHospitalList);
    this.$mainSignalr.bus.$off('WaitInHospitalList', this.throttledMainListAdmission);
    this.$mobileSignalr.bus.$off('WaitInHospitalList', this.throttledMainListAdmission);
    this.$mainSignalr.bus.$off('OutOfServiceHospital', this.throttledOutOfServiceHospital);
    this.$mobileSignalr.bus.$off('OutOfServiceHospital', this.throttledOutOfServiceHospital);

    this.$mainSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);
    this.$mobileSignalr.bus.$off('DispatchNotification', this.fNotifyOutOfService);

    this.throttledMainListAdmission.cancel();
    this.throttledHospitalList.cancel();
    this.throttledOutOfServiceHospital.cancel();

    delete this.$root.$refs.MissionAdmissionView;
  },
  mounted() {
    this.mounteLoding();
  },
  data() {
    return {
      showColumnManager: false,
      currentHeaders: [],
      withPopup: latLng(30.2839, 57.0834),
      withTooltip: latLng(30.2839, 57.0834),
      currentZoom: 12,
      currentCenter: latLng(30.2839, 57.0834),
      showParagraph: false,
      mapOptions: {
        zoomSnap: 0.5,
        scrollWheelZoom: true,
      },
      movingIconForPhoneWithMission: require('@/assets/images/phoneWithMission.svg'),
      movingIconForPhoneWithOutMission: require('@/assets/images/phoneWithOutMission.svg'),
      movingIconForGPSWithMission: require('@/assets/images/gpsWithMission.svg'),
      movingIconForGPSWithOutMission: require('@/assets/images/gpsWithOutMission.svg'),
      stopIconForPhoneWithMission: require('@/assets/images/stopphoneWithMission.svg'),
      stopIconForPhoneWithOutMission: require('@/assets/images/stopphoneWithOutMission.svg'),
      stopIconForGPSWithMission: require('@/assets/images/stopgpsWithMission.svg'),
      stopIconForGPSWithOutMission: require('@/assets/images/stopgpsWithOutMission.svg'),
      dragging: false,
      icon: this.getIcon,
      hospitalIcon: L.icon({
        iconUrl: require('@/assets/images/hospitalMarker.svg'),
        iconSize: [22, 27],
        iconAnchor: [11, 30],
      }),
    };
  },
  methods: {
    invokeToCodeInMap: function (value, data) {
      try {

        this.selectedRow = data.item?.id;
        this.clickItem = value;
        const connection = Vue.prototype.$mainSignalr?.connection;
        if (!connection || connection.state !== 'Connected') {
          console.log('[SignalR2] connection not ready');
          return;
        }
        connection.invoke('Location', data.item.ambulanceCode.toString()).catch((err) => {
          console.log('[SignalR2] invoke Location failed:', err);
        });
      } catch (error) {
        console.log("A error:", error);
      }
    },
    truncateText(text, maxLength = 20) {
      if (!text) return '';
      if (text.length <= maxLength) return text;
      return text.substring(0, maxLength) + '...';
    },
    shouldShowSpecialStatus(status) {
      const hasAnyItem = this.specialStatuses.some(item => status?.includes(item));

      return hasAnyItem ||
        status?.includes("استقرار") ||
        status?.startsWith("بیمارستان") ||
        status === "درخواست کد سما";
    },
    mounte: function () {
      L.Icon.Default.mergeOptions({
        iconRetinaUrl: require('@/assets/images/marker-icon-2x.png'),
        iconUrl: require('@/assets/images/marker-icon.png'),
        shadowUrl: require('@/assets/images/marker-shadow.png'),
      });

      this.getAllUserGridSettingsFunction('MainListAdmission').then((resolve) => {

        if (resolve?.length > 0) {
          let temp = resolve?.find((item) => item?.gridName == 'MainListAdmission');
          if (temp?.settingsJson) {
            try {
              this.currentHeaders = JSON.parse(temp?.settingsJson);
            } catch (e) {
              this.currentHeaders = [...this.admissionTopListTableHeader];
            }
          } else {
            this.currentHeaders = [...this.admissionTopListTableHeader];
          }
        } else {
          this.currentHeaders = [...this.admissionTopListTableHeader];
        }
      })

      // Initial loads go through the same latest-wins guards (with loader shown),
      // so a signal arriving during first load can't stack a parallel request.
      this.refreshAdmissionList(true);
      this.refreshHospitalList(true);
      this.refreshOutOfServiceList(true);
      // this.getListOfAllActiveAlarmOutOfServiceHospitalsFunction();
      this.setMapBaseSystemSetting();
      this.getListOfOtherOrganizationsForOther();
    },
    refreshAdmissionList: function (showLoad) {
      if (this.admissionInFlight) {
        this.admissionPending = true;
        return;
      }
      this.admissionInFlight = true;
      Promise.resolve(this.getListOfCurrentMissionsForAdmissionFunction(showLoad)).finally(() => {
        this.admissionInFlight = false;
        if (this.admissionPending) {
          this.admissionPending = false;
          this.refreshAdmissionList(false);
        }
      });
    },
    refreshHospitalList: function (showLoad) {
      if (this.hospitalInFlight) {
        this.hospitalPending = true;
        return;
      }
      this.hospitalInFlight = true;
      Promise.resolve(this.getListOfHospitalsForAdMissionFunction(showLoad)).finally(() => {
        this.hospitalInFlight = false;
        if (this.hospitalPending) {
          this.hospitalPending = false;
          this.refreshHospitalList(false);
        }
      });
    },
    refreshOutOfServiceList: function (showLoad) {
      if (this.outOfServiceInFlight) {
        this.outOfServicePending = true;
        return;
      }
      this.outOfServiceInFlight = true;
      Promise.resolve(this.getListOfAllActiveOutOfServiceHospitalsFunction(showLoad)).finally(() => {
        this.outOfServiceInFlight = false;
        if (this.outOfServicePending) {
          this.outOfServicePending = false;
          this.refreshOutOfServiceList(false);
        }
      });
    },
    //map
    centerUpdate(center) {
      this.currentCenter = center;
    },
    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    mapInvalidate: function () {
      setTimeout(() => {
        this.$refs.modalmap.mapObject.invalidateSize();
      }, 100);
      setTimeout(() => {
        this.$refs.marker.mapObject.openPopup();
      }, 300);
    },
    getMovingIcon(data) {
      if (data.speed >= 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.movingIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                data.angle +
                'deg)"/>',
            });
          }
        }
      } else if (data.speed < 2) {
        if (data.isPhoneLocation == true) {
          //is phone
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForPhoneWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        } else if (data.isPhoneLocation == false) {
          //is gps
          if (data.hasMission == true) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          } else if (data.hasMission == false) {
            return L.divIcon({
              className: 'my-custom-pin',
              html:
                '<img src="' +
                this.stopIconForGPSWithOutMission +
                '" style="width:20px; height:20px; transform:rotate(' +
                0 +
                'deg)"/>',
            });
          }
        }
      }
    },
    fNotifyOutOfService: function (data) {
      if (data?.text?.includes('بیمارستان') || data?.text?.includes('247') || data?.text?.includes('724')) {
        this.showTostMessage2(data?.text, '', {
          timeout: false,
          closeOnClick: false,
          pauseOnFocusLoss: false,
          pauseOnHover: false,
        })
      }
    },
    getRealColumnWidths() {
      const table = document.querySelector('#admission_top_table table');
      if (!table) {
        return null;
      }

      const headerCells = table.querySelectorAll('thead tr th');
      if (!headerCells.length) {
        return null;
      }

      const widths = [];
      headerCells.forEach((th) => {
        const width = th.getBoundingClientRect().width;
        widths.push(Math.round(width));
      });
      return widths;
    },
    openColumnManager() {
      const realWidths = this.getRealColumnWidths();

      if (realWidths) {
        const headersWithWidth = this.currentHeaders.map((h, index) => ({
          ...h,
          width: realWidths[index] ? realWidths[index] : (h.width || 120),
        }));

        this.currentHeaders = headersWithWidth;
      }

      this.showColumnManager = true;
      const icon = document.getElementById('iconDatabase');
      if (icon) icon.blur();
    },
    applyNewHeaders(newHeaders) {
      this.currentHeaders = newHeaders;
      this.setUserGridSettingFunction({
        gridName: "MainListAdmission",
        settingsJson: JSON.stringify(newHeaders)
      })
    },
  },
  computed: {
    visibleRightClickItems() {
      return this.rightClickItems.filter(item => {
        if (item.title === 'تماس با بیمارستان') {
          return this.hospitalPhoneNumbers_mission?.length > 0;
        }
        return true;
      });
    },
    specialStatuses() {
      const fixed = ["10-33", "10-99", "10-19", "10-12", "10-51", "10-10", "10-63", "10-60", "10-7", "10-24", "247", "724", '10-51'];
      const apiTitles = this.allOtherOrganizationsForOther?.map(item => item.title);
      return [...fixed, ...apiTitles];
    },
  }
};
</script>
<style scoped>
>>>.top-table .v-data-table__wrapper table {
  table-layout: fixed;
}

>>>table tbody tr td {
  padding-top: 4px !important;
  padding-bottom: 3px !important;
}

.alarmTxtIcon {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 3px;

}

.topControlBox {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
  width: 100%;
  margin-bottom: 20px;
  margin-top: -32px;
}

.note-multiline {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  line-height: 1.5;
  max-height: 4.5em;
  cursor: help;
}

.bottom-list-status-10-99 {
  background: #ff9c78 !important;
  border-radius: 5px !important;
  color: white;
}

.admission-missions-container {
  max-height: calc(100dvh - 62px);
  overflow-y: auto;
  overflow-x: hidden;
  padding-left: 10px;
  height: 100vh;
}

.mission-800-list-card {
  border: 1px solid var(--dark-color) !important;
  background: white !important;
}

>>>.top-table.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.top-table .v-data-table__wrapper table tbody tr td {
  font-size: 13px !important;
}

>>>.top-table .v-data-table-header tr th {
  font-size: 12px !important;
}

.covered-position {
  margin-top: -3.5vh !important;
}

.current-mission-header-content {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, white 50%);
  padding-right: 10px !important;
  padding-left: 20px !important;
}

.covered-position2 {
  margin-top: -4.2vh !important;
}

>>>.current-mission-text-field {
  width: 35vh !important;
  max-width: 35vh !important;
}

>>>.current-mission-text-field fieldset {
  background: white !important;
}

>>>.current-mission-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.current-mission-text-field.v-input input {
  max-height: 30px !important;
}

/*bottom list 88888888888888888888888888888888888888888888888888888888888888888888888888888888888888*/
/*first*/
.first-bottom-list-main-card {
  border: 1px solid var(--dark-color) !important;
  background: #fffadb !important;
}

.stay-hospital-header-content {
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, #fffadb 50%);
  padding-right: 5px !important;
  padding-left: 5px !important;
  font-size: 12px;
  white-space: nowrap;
}

>>>.stay-hospital-text-field fieldset {
  background: white !important;
}

>>>.stay-hospital-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.stay-hospital-text-field.v-input input {
  max-height: 30px !important;
}

.stay-table,
>>>.stay-table table thead tr th {
  background: #fffadb !important;
}

>>>.stay-table.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.stay-table .v-data-table__wrapper table tbody tr td {
  font-size: 12px !important;
}

>>>.stay-table .v-data-table-header tr th {
  font-size: 11px !important;
}

/*second */
.second-bottom-list-main-card {
  border: 1px solid var(--dark-color) !important;
  background: #e6ffee !important;
}

.hospital-header-content {
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, #e6ffee 50%);
  padding-right: 5px !important;
  padding-left: 5px !important;
  font-size: 12px;
}

>>>.hospital-text-field fieldset {
  background: white !important;
}

>>>.hospital-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.hospital-text-field.v-input input {
  max-height: 30px !important;
}

.hospital-table,
>>>.hospital-table table thead tr th {
  background: #e6ffee !important;
}

>>>.hospital-table.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.hospital-table .v-data-table__wrapper table tbody tr td {
  font-size: 12px !important;
}

>>>.hospital-table .v-data-table-header tr th {
  font-size: 11px !important;
}

/*third */
.third-bottom-list-main-card {
  border: 1px solid var(--dark-color) !important;
  background: #ffe8f7 !important;
}

.out-of-service-header-content {
  color: var(--dark-color) !important;
  background-image: linear-gradient(to bottom, var(--background-color) 50%, #ffe8f7 50%);
  padding-right: 5px !important;
  padding-left: 5px !important;
  font-size: 12px;
  white-space: nowrap;
}

>>>.out-of-service-text-field {
  /* width: 35vh !important; */
  max-width: 350px !important;
}

>>>.out-of-service-text-field fieldset {
  background: white !important;
}

>>>.out-of-service-text-field .v-input__control .v-input__slot {
  min-height: 15px !important;
}

>>>.out-of-service-text-field.v-input input {
  max-height: 30px !important;
}

.out-of-service-table,
>>>.out-of-service-table table thead tr th {
  background: #ffe8f7 !important;
}

>>>.out-of-service-table.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tbody>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>tfoot>tr>th,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>td,
.v-data-table--dense>.v-data-table__wrapper>table>thead>tr>th {
  height: 23px !important;
}

>>>.out-of-service-table .v-data-table__wrapper table tbody tr td {
  font-size: 12px !important;
}

>>>.out-of-service-table .v-data-table-header tr th {
  font-size: 11px !important;
}

>>>.out-of-service-table table tbody tr td:nth-child(5),
>>>.out-of-service-table table thead tr th:nth-child(5) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0 !important;
  z-index: 98 !important;
  background: #ffe8f7 !important;
}

.out-of-service-tabletable>thead>tr>th:nth-child(5) {
  z-index: 99 !important;
}


.has-alarm-part {
  height: 25vh !important;
  overflow-y: auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.all-active-alarm-card {
  border-left: 1px solid var(--dark-color) !important;
  border-right: 1px solid var(--dark-color) !important;
  background: #fff5f3 !important;
  border-radius: 10px !important;
}

>>>.all-active-alarm-card-body {
  height: 7vh !important;
  background: white !important;
  margin-top: 0.5vh !important;
  border-radius: 10px !important;
}

.all-active-alarm-card-body-items-title {
  font-size: 14px;
  font-weight: 600;
  color: #212121;
}

.all-active-alarm-card-body-items-value {
  color: #333333;
  font-size: 13px;
  font-weight: 400;
}

.all-active-alarm-card-body-items-value-time {
  color: var(--dark-color) !important;
}

.card-info-send-mission {
  border-right: 3px solid var(--dark-color) !important;
  border-left: 3px solid var(--dark-color) !important;
  border-top: 2px solid var(--background-color) !important;
  border-bottom: 2px solid var(--background-color) !important;
  border-radius: 10px !important;
}

.x-overflow {
  overflow-x: auto !important;
}

.send-mission-detail-card {
  border: 1px solid var(--dark-color) !important;
}

.send-mission-title-content {
  color: var(--dark-color) !important;
  font-weight: 500;
  font-size: 11px;
  background: white !important;
  margin-top: -1.5vh !important;
  margin-right: 2vh !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.send-mission-title-content2 {
  color: var(--dark-color) !important;
  font-weight: 500;
  font-size: 13px;
}

.send-mission-info-title-content {
  color: #212121 !important;
  font-weight: 500;
  font-size: 14px;
}

.send-mission-info-text-content {
  color: #212121 !important;
  font-weight: 400;
  font-size: 12px;
}

.mission-card-header-rank-title {
  font-weight: 500;
  font-size: 14px;
  color: #212121 !important;
}

.mission-card-header-rank-text {
  font-weight: 400;
  font-size: 13px;
  color: #212121 !important;
}

.modal-active-tab {
  cursor: pointer;
  background: #f3f5ff !important;
  padding-left: 12px !important;
  padding-right: 12px !important;
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  color: var(--dark-color) !important;
  border-radius: 5px !important;
}

.modal-deactive-tab {
  cursor: pointer;
  background: #ffffff !important;
  color: #212121 !important;
}

.note-box {
  border: 1px solid #909090 !important;
  border-radius: 12px !important;
}

.not-box-title {
  position: absolute;
  background: white;
  padding-right: 20px !important;
  margin-top: -1.4vh !important;
  margin-right: 45px !important;
}

.note-box-input {
  margin-top: 2.5vh !important;
}

.note-component-space {
  height: 50vh !important;
  overflow-y: auto !important;
}

.send-mission-detail-card-body {
  height: 12vh !important;
  overflow-y: auto !important;
}

th {
  position: sticky !important;
  top: 0 !important;
  background: white !important;
  z-index: 2 !important;
}
</style>
